export default "__VITE_ASSET__MWPY7kZa__"